import NotAvailable from "@/assets/not-available.svg";
import { ErrorPage } from "@/components/ErrorPage";
import { getCoWorkerProfileLanguage } from "@/utils/getCoWorkerLanguage";
import { t } from "@repo/translation";
import { trackAnalytics } from "@repo/utils";
import { useEffect } from "react";

export const NoAccessPage = () => {
  useEffect(() => {
    trackAnalytics("no_access_page");
  }, []);

  const profile = getCoWorkerProfileLanguage();
  const url = profile
    ? `${window.location.origin}/${profile?.market}/${profile?.language}`
    : undefined;

  return (
    <ErrorPage
      image={<NotAvailable />}
      title={t("prompt.no_access_to_market")}
      description={t("prompt.no_access_to_market_desc")}
      link={url}
      buttonText={t("action.go_to_home_market")}
    />
  );
};
